import { Link } from 'react-router-dom';
import { getProductPath } from '@/utils/productLinks';

interface RelatedProduct {
  id: number;
  title: string;
  image: string;
  category: string;
  compliance: string;
}

interface RelatedProductsProps {
  products: RelatedProduct[];
}

export default function RelatedProducts({ products }: RelatedProductsProps) {
  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">You Might Also Like</h2>
          <p className="text-lg text-gray-600">
            Explore our complete range of fire safety products and solutions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {products.map((product) => (
            <Link
              key={product.id}
              to={getProductPath(product.id)}
              className="group bg-white rounded-lg shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden"
            >
              <div className="aspect-video bg-gray-100 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-xs font-medium text-red-600 bg-red-50 px-2 py-1 rounded">
                    {product.category}
                  </span>
                  <span className="text-xs text-gray-500">{product.compliance}</span>
                </div>
                <h3 className="font-semibold text-gray-900 group-hover:text-red-600 transition-colors">
                  {product.title}
                </h3>
                <div className="mt-4 flex items-center text-red-600 text-sm font-medium">
                  <span>View Details</span>
                  <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}